export default [
  {
    path: '',
    name: 'apps-stakeholder-list',
    component: () => import(/* webpackChunkName: "apps-stakeholder-list" */ '@/apps/stakeholder/pages/StakeholderListPage.vue'),
    meta: {
      layout: 'content',
    },
  },
]
